import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

export const THEMES = {
  mars_orange: {
    id: "mars_orange",
    name: "Power",
    planet: "Mars",
    color: "#FF4500",
    shortLabel: "Mars · Power",
  },
  jupiter_gold: {
    id: "jupiter_gold",
    name: "Wisdom",
    planet: "Jupiter",
    color: "#F5A623",
    shortLabel: "Jupiter · Wisdom",
  },
  mercury_cyan: {
    id: "mercury_cyan",
    name: "Harmony",
    planet: "Mercury",
    color: "#00BCD4",
    shortLabel: "Mercury · Harmony",
  },
};

const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
  const [themeId, setThemeIdState] = useState(() => {
    const stored = typeof window !== "undefined" ? localStorage.getItem("powerTheme") : null;
    return stored && THEMES[stored] ? stored : "jupiter_gold";
  });

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", themeId);
    localStorage.setItem("powerTheme", themeId);
  }, [themeId]);

  const setThemeId = useCallback((id) => {
    if (THEMES[id]) setThemeIdState(id);
  }, []);

  return (
    <ThemeContext.Provider value={{ themeId, setThemeId, theme: THEMES[themeId], themes: THEMES }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error("useTheme must be used within ThemeProvider");
  return ctx;
}
